// @license
// Powerhouse-theme, by Logicgo Themes


document.addEventListener('DOMContentLoaded', function() {
    // Select all product links in the Recommended Products section
    var recommendedProductLinks = document.querySelectorAll('.recommended-products a');

    // Loop through each link and remove the URL parameters
    recommendedProductLinks.forEach(function(link) {
        var url = new URL(link.href);
        link.href = url.origin + url.pathname; // This keeps only the base URL and removes query params
    });
});


// hero slider js

document.addEventListener('DOMContentLoaded', function () {
  var herosliderSwipers = [];

  function initherosliderSwiper(swiperContainer) {
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var slider = swiperContainer.dataset.slider;
      var breakpoints = {};
    if(slider === 'second_slider'){
      breakpoints = {
          1200: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          991: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          768: {
            slidesPerView: 2
          },
          480: {
            slidesPerView: 1
          }
        };
    }
      var herosliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          navigation: {
              nextEl: swiperContainer.querySelector(".slider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".slider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".slider-swiper-pagination"),
              clickable: true,
          },
          breakpoints: breakpoints
      });

      herosliderSwipers.push(herosliderSwiper);
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
      initherosliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
      document.querySelectorAll('.classic-container').forEach(function (swiperContainer) {
          initherosliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
  });
});


// Best selling collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var BestsellingcollectionSwipers = [];

  function initBestsellingcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var sliderrow = swiperContainer.dataset.sliderrow;
      var tabletrow = swiperContainer.dataset.tabletrow;
      var mobilerow = swiperContainer.dataset.mobilerow;

      var BestsellingcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          grid: {
            rows: sliderrow
          },
          navigation: {
              nextEl: swiperContainer.querySelector(".bestselling-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".bestselling-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".bestselling-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace,
                grid: {
                  rows: mobilerow
                }
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
                grid: {
                  rows: tabletrow
                }
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace,
                grid: {
                  rows: tabletrow
                }
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                grid: {
                  rows: sliderrow
                }
            },
        },
      });

      BestsellingcollectionSwipers.push(BestsellingcollectionSwiper);
  }

  // Initialize Bestselling collection Swiper on page load
  document.querySelectorAll('.bestselling-slider').forEach(function (swiperContainer) {
      initBestsellingcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Bestselling collection Swiper on section select
      BestsellingcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BestsellingcollectionSwipers = [];
      document.querySelectorAll('.bestselling-slider').forEach(function (swiperContainer) {
          initBestsellingcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Deal collection Swiper on section deselect if necessary
      BestsellingcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BestsellingcollectionSwipers = [];
  });
});

// featured collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedcollectionSwipers = [];

  function initFeaturedcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var sliderrow = swiperContainer.dataset.sliderrow;
      var tabletrow = swiperContainer.dataset.tabletrow;
      var mobilerow = swiperContainer.dataset.mobilerow;


      var FeaturedcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          grid: {
            rows: sliderrow
          },
          navigation: {
              nextEl: swiperContainer.querySelector(".featured-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".featured-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".featured-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace,
                grid: {
                  rows: mobilerow
                }
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace,
                grid: {
                  rows: tabletrow
                }
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace,
                grid: {
                  rows: tabletrow
                }
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace,
                grid: {
                  rows: sliderrow
                }
            },
        },
      });

      FeaturedcollectionSwipers.push(FeaturedcollectionSwiper);
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
      initFeaturedcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured collection Swiper on section select
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
      document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
          initFeaturedcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured collection Swiper on section deselect if necessary
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
  });
});

// Deal collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var DealcollectionSwipers = [];

  function initDealcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var DealcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".deal-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".deal-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".deal-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: largeTablet,
                spaceBetween: desktopspace
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      DealcollectionSwipers.push(DealcollectionSwiper);
  }

  // Initialize Deal collection Swiper on page load
  document.querySelectorAll('.deal-slider').forEach(function (swiperContainer) {
      initDealcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Deal collection Swiper on section select
      DealcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      DealcollectionSwipers = [];
      document.querySelectorAll('.deal-slider').forEach(function (swiperContainer) {
          initDealcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Deal collection Swiper on section deselect if necessary
      DealcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      DealcollectionSwipers = [];
  });
});

// tab collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var TabcollectionSwipers = [];

  function initTabcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      

    if (enable) {
      var TabcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".tab-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".tab-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".tab-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      TabcollectionSwipers.push(TabcollectionSwiper);
    }
  }

  // Initialize Tab collection Swiper on page load
  document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
      initTabcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Tab collection Swiper on section select
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
      document.querySelectorAll('.tab-slider').forEach(function (swiperContainer) {
          initTabcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Tab collection Swiper on section deselect if necessary
      TabcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TabcollectionSwipers = [];
  });
});

// testimonial slider js

document.addEventListener('DOMContentLoaded', function () {
  var TestimonialSwipers = [];

  function initTestimonialSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var TestimonialSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".testimonial-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".testimonial-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".testimonial-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            841: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30
            },
        },
      });

      TestimonialSwipers.push(TestimonialSwiper);
  }

  // Initialize Testimonial collection Swiper on page load
  document.querySelectorAll('.testimonial-slider').forEach(function (swiperContainer) {
      initTestimonialSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Testimonial collection Swiper on section select
      TestimonialSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TestimonialSwipers = [];
      document.querySelectorAll('.testimonial-slider').forEach(function (swiperContainer) {
          initTestimonialSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Testimonial collection Swiper on section deselect if necessary
      TestimonialSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TestimonialSwipers = [];
  });
});

// shipping slider js

document.addEventListener('DOMContentLoaded', function () {
  var ShippingSwipers = [];

  function initShippingSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var ShippingSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".shipping-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".shipping-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".shipping-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30
            },
        },
      });

      ShippingSwipers.push(ShippingSwiper);
  }

  // Initialize Shipping collection Swiper on page load
  document.querySelectorAll('.Shipping-inner-row').forEach(function (swiperContainer) {
      initShippingSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Shipping collection Swiper on section select
      ShippingSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ShippingSwipers = [];
      document.querySelectorAll('.Shipping-inner-row').forEach(function (swiperContainer) {
          initShippingSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Shipping collection Swiper on section deselect if necessary
      ShippingSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ShippingSwipers = [];
  });
});

// blog slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedblogSwipers = [];

  function initFeaturedblogSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
  
      var FeaturedblogSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".blog-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".blog-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".blog-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

    FeaturedblogSwipers.push(FeaturedblogSwiper);
  }

  // Initialize Featured blog Swiper on page load
  document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
      initFeaturedblogSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured blog Swiper on section select
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
      document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
          initFeaturedblogSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured blog Swiper on section deselect if necessary
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
  });
});

// brand slider js

document.addEventListener('DOMContentLoaded', function () {
  var BrandSwipers = [];

  function initBrandSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var autoplay = swiperContainer.dataset.autoplay === "true";

      var BrandSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 0,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".brand-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".brand-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".brand-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            841: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 0
            },
        },
      });

      BrandSwipers.push(BrandSwiper);
  }

  // Initialize Brand Swiper on page load
  document.querySelectorAll('.brand-slider').forEach(function (swiperContainer) {
      initBrandSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Brand Swiper on section select
      BrandSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BrandSwipers = [];
      document.querySelectorAll('.brand-slider').forEach(function (swiperContainer) {
          initBrandSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Brand Swiper on section deselect if necessary
      BrandSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BrandSwipers = [];
  });
});

// multicolumn slider
document.addEventListener('DOMContentLoaded', function () {
  var MulticolumnSwipers = [];

  function initmulticolumnSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var MulticolumnSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".multicolumn-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".multicolumn-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".multicolumn-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30
            },
        },
      });

    MulticolumnSwipers.push(MulticolumnSwiper);
  }

  // Initialize Multicolumn Swiper on page load
  document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
      initmulticolumnSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Multicolumn Swiper on section select
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
      document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
          initmulticolumnSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Multicolumn Swiper on section deselect if necessary
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
  });
});

// instagram slider
document.addEventListener('DOMContentLoaded', function () {
  var InstagramSwipers = [];

  function initInstagramSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable === "true";
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

    if (enable) {
      var InstagramSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".instagram-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".instagram-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".instagram-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30
            },
        },
      });

      InstagramSwipers.push(InstagramSwiper);
    }
  }

  // Initialize Instagram Swiper on page load
  document.querySelectorAll('.main-instagram-post-section-wrapper').forEach(function (swiperContainer) {
      initInstagramSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Instagram Swiper on section select
      InstagramSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      InstagramSwipers = [];
      document.querySelectorAll('.main-instagram-post-section-wrapper').forEach(function (swiperContainer) {
          initInstagramSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Instagram Swiper on section deselect if necessary
      InstagramSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      InstagramSwipers = [];
  });
});

// hero slideshow style2 slider

document.addEventListener('DOMContentLoaded', function () {
  var heroslider2Swipers = [];

  function initheroslider2Swiper(swiperContainer) {
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
    
      var heroslider2Swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".slider2-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".slider2-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".slider2-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: 1
            },
            576: {
                slidesPerView: 1
            },
            841: {
                slidesPerView: 1
            },
            992: {
                slidesPerView: 1
            },
        },
      });
  
      heroslider2Swipers.push(heroslider2Swiper);
  }

  // Initialize Hero slider 2 Swiper on page load
  document.querySelectorAll('.swiper-container-gudget').forEach(function (swiperContainer) {
      initheroslider2Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider 2 Swiper on section select
      heroslider2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      heroslider2Swipers = [];
      document.querySelectorAll('.swiper-container-gudget').forEach(function (swiperContainer) {
          initheroslider2Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider 2 Swiper on section deselect if necessary
      heroslider2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      heroslider2Swipers = [];
  });
});

// category style 4 section slider

document.addEventListener('DOMContentLoaded', function () {
  var CmssliderSwipers = [];

  function initcmssliderSwiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var cmssliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".cmsslider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".cmsslider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".cmsslider-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
          }
      });

    CmssliderSwipers.push(cmssliderSwiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.cms-slider-container').forEach(function (swiperContainer) {
      initcmssliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      CmssliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      CmssliderSwipers = [];
      document.querySelectorAll('.cms-slider-container').forEach(function (swiperContainer) {
          initcmssliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      CmssliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      CmssliderSwipers = [];
  });
});

// featured product section slider

document.addEventListener('DOMContentLoaded', function () {
  var featuredproductSwipers = [];

  function initfeaturedproductSwiper(swiperContainer) {
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var featuredproductSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".slider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".slider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".slider-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: 1
            },
            480: {
                slidesPerView: 1
            },
            576: {
                slidesPerView: 1
            },
            841: {
                slidesPerView: 1
            },
            992: {
                slidesPerView: 1
            },
            1200: {
                slidesPerView: 1
            },
          }
      });

    featuredproductSwipers.push(featuredproductSwiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.featured_slider').forEach(function (swiperContainer) {
      initfeaturedproductSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      featuredproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      featuredproductSwipers = [];
      document.querySelectorAll('.featured_slider').forEach(function (swiperContainer) {
          initfeaturedproductSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      featuredproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      featuredproductSwipers = [];
  });
});

// category section slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollectionSwipers = [];

  function initcategorycollectionSwiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var categorycollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".category-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".category-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".category-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: largeTablet,
                spaceBetween: 30,
            },
            1367: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
          }
      });

    categorycollectionSwipers.push(categorycollectionSwiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.category1-collection').forEach(function (swiperContainer) {
      initcategorycollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      categorycollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollectionSwipers = [];
      document.querySelectorAll('.category1-collection').forEach(function (swiperContainer) {
          initcategorycollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      categorycollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollectionSwipers = [];
  });
});

// category collection 2 slider js

document.addEventListener('DOMContentLoaded', function () {
  var categorycollectionstyle4Swipers = [];

  function initcategorycollectionstyle4Swiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var sliderrow = swiperContainer.dataset.sliderrow;
      var tabletrow = swiperContainer.dataset.tabletrow;
      var mobilerow = swiperContainer.dataset.mobilerow;

      var categorycollectionstyle4Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 0,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          grid: {
              rows: sliderrow
          },
          navigation: {
              nextEl: swiperContainer.querySelector(".two-category-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".two-category-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".two-category-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 0,
                grid: {
                  rows: mobilerow
                }
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 0,
                grid: {
                      rows: tabletrow
                }
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 0,
                grid: {
                    rows: tabletrow
                }
            },
            992: {
                slidesPerView: largeTablet,
                spaceBetween: 0,
                grid: {
                  rows: sliderrow
                }
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 0,
                grid: {
                  rows: sliderrow
                }
            },
          },
      });

    categorycollectionstyle4Swipers.push(categorycollectionstyle4Swiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-collections-list-wrapper2').forEach(function (swiperContainer) {
      initcategorycollectionstyle4Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection style4 Swiper on section select
      categorycollectionstyle4Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollectionstyle4Swipers = [];
      document.querySelectorAll('.main-collections-list-wrapper2').forEach(function (swiperContainer) {
          initcategorycollectionstyle4Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection style4 Swiper on section deselect if necessary
      categorycollectionstyle4Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollectionstyle4Swipers = [];
  });
});

// category collection 3 slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollection3Swipers = [];

  function initcategorycollection3Swiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var categorycollection3Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".category3-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".category3-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".category3-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
          }
      });

    categorycollection3Swipers.push(categorycollection3Swiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.main-collections-list-3').forEach(function (swiperContainer) {
      initcategorycollection3Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      categorycollection3Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection3Swipers = [];
      document.querySelectorAll('.main-collections-list-3').forEach(function (swiperContainer) {
          initcategorycollection3Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      categorycollection3Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollection3Swipers = [];
  });
});

// category collection 4 slider

document.addEventListener('DOMContentLoaded', function () {
  var CmssliderSwipers = [];

  function initcmssliderSwiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var cmssliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".cmsslider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".cmsslider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".cmsslider-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: largeTablet,
                spaceBetween: 30,
            },
            1100: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
          }
      });

    CmssliderSwipers.push(cmssliderSwiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.cms-slider-container').forEach(function (swiperContainer) {
      initcmssliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      CmssliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      CmssliderSwipers = [];
      document.querySelectorAll('.cms-slider-container').forEach(function (swiperContainer) {
          initcmssliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      CmssliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      CmssliderSwipers = [];
  });
});

// category collection 5 slider

document.addEventListener('DOMContentLoaded', function () {
  var categorycollectionSwipers = [];

  function initcategorycollectionSwiper(swiperContainer) {

      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var categorycollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".category5-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".category5-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".category5-swiper-pagination"),
              clickable: true,
          },
          breakpoints : {
            320: {
                slidesPerView: mobile,
                spaceBetween: 15,
            },
            480: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 15,
            },
            841: {
                slidesPerView: largeTablet,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: desktop,
                spaceBetween: 30,
            },
          }
      });

    categorycollectionSwipers.push(categorycollectionSwiper);
  }

  // Initialize category collection Swiper on page load
  document.querySelectorAll('.category5-slider').forEach(function (swiperContainer) {
      initcategorycollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize category collection Swiper on section select
      categorycollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollectionSwipers = [];
      document.querySelectorAll('.category5-slider').forEach(function (swiperContainer) {
          initcategorycollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup category collection Swiper on section deselect if necessary
      categorycollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      categorycollectionSwipers = [];
  });
});